import React from 'react';

import EditProfile from './EditProfile';
import AdminLayout from '../../../components/Layout/AdminLayout';

import { checkListing } from '../../../actions/Listing/checkListing';
import messages from '../../../locale/messages';
import NotFound from '../../notFound/NotFound';

export default async function action({ store, params, intl }) {

    const title = intl?.formatMessage(messages.editProfile);
    let isAdminAuthenticated, response, profile, isUser;

    isAdminAuthenticated = store.getState()?.runtime?.isAdminAuthenticated;

    const profileId = params.profileId;
    await store.dispatch(checkListing(profileId, 'profile')).then(function (res) {
        response = res;
    });

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    const data = store.getState()?.account?.data;
    profile = Number(profileId);
    isUser = !profileId && data ? true : false;

    return {
        title,
        component: <AdminLayout><EditProfile profileId={profile} response={response} /></AdminLayout>
    };
}
